// Brand assets for Tour Trips India Holidays
// Local trimmed logo (JPG version, no transparent padding) — served from /app/frontend/public
export const LOGO_URL = "/logo-trimmed.jpg";

export const BRAND = {
  name: "Tour Trips India Holidays",
  short: "TTI Holidays",
  tagline: "Let's Explore...",
  phone: "+917017798524",
  phoneDisplay: "+91 70177 98524",
  email: "info@ttiholidays.com",
  address: "P-10, Tajnagri Phase 1, Tajganj, Agra – 282001 (U.P.), India",
};
